// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkflowStatusPendingApprovalsInner } from './workflow-status-pending-approvals-inner';
import {
    WorkflowStatusPendingApprovalsInnerFromJSON,
    WorkflowStatusPendingApprovalsInnerFromJSONTyped,
    WorkflowStatusPendingApprovalsInnerToJSON,
    WorkflowStatusPendingApprovalsInnerToJSONTyped,
} from './workflow-status-pending-approvals-inner';
import type { WorkflowStatusTransitionHistoryInner } from './workflow-status-transition-history-inner';
import {
    WorkflowStatusTransitionHistoryInnerFromJSON,
    WorkflowStatusTransitionHistoryInnerFromJSONTyped,
    WorkflowStatusTransitionHistoryInnerToJSON,
    WorkflowStatusTransitionHistoryInnerToJSONTyped,
} from './workflow-status-transition-history-inner';
import type { WorkflowStatusNextActionsInner } from './workflow-status-next-actions-inner';
import {
    WorkflowStatusNextActionsInnerFromJSON,
    WorkflowStatusNextActionsInnerFromJSONTyped,
    WorkflowStatusNextActionsInnerToJSON,
    WorkflowStatusNextActionsInnerToJSONTyped,
} from './workflow-status-next-actions-inner';

/**
 * 
 * @export
 * @interface WorkflowStatus
 */
export interface WorkflowStatus {
    /**
     * 
     * @type {boolean}
     * @memberof WorkflowStatus
     */
    can_transition: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatus
     */
    current_stage: string;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatus
     */
    dta_id: string;
    /**
     * 
     * @type {Array<WorkflowStatusNextActionsInner>}
     * @memberof WorkflowStatus
     */
    next_actions: Array<WorkflowStatusNextActionsInner>;
    /**
     * 
     * @type {Array<WorkflowStatusPendingApprovalsInner>}
     * @memberof WorkflowStatus
     */
    pending_approvals: Array<WorkflowStatusPendingApprovalsInner>;
    /**
     * 
     * @type {Array<WorkflowStatusTransitionHistoryInner>}
     * @memberof WorkflowStatus
     */
    transition_history: Array<WorkflowStatusTransitionHistoryInner>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkflowStatus
     */
    transition_options: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof WorkflowStatus
     */
    workflow_stage: string;
}

/**
 * Check if a given object implements the WorkflowStatus interface.
 */
export function instanceOfWorkflowStatus(value: object): value is WorkflowStatus {
    if (!('can_transition' in value) || value['can_transition'] === undefined) return false;
    if (!('current_stage' in value) || value['current_stage'] === undefined) return false;
    if (!('dta_id' in value) || value['dta_id'] === undefined) return false;
    if (!('next_actions' in value) || value['next_actions'] === undefined) return false;
    if (!('pending_approvals' in value) || value['pending_approvals'] === undefined) return false;
    if (!('transition_history' in value) || value['transition_history'] === undefined) return false;
    if (!('transition_options' in value) || value['transition_options'] === undefined) return false;
    if (!('workflow_stage' in value) || value['workflow_stage'] === undefined) return false;
    return true;
}

export function WorkflowStatusFromJSON(json: any): WorkflowStatus {
    return WorkflowStatusFromJSONTyped(json, false);
}

export function WorkflowStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'can_transition': json['can_transition'],
        'current_stage': json['current_stage'],
        'dta_id': json['dta_id'],
        'next_actions': ((json['next_actions'] as Array<any>).map(WorkflowStatusNextActionsInnerFromJSON)),
        'pending_approvals': ((json['pending_approvals'] as Array<any>).map(WorkflowStatusPendingApprovalsInnerFromJSON)),
        'transition_history': ((json['transition_history'] as Array<any>).map(WorkflowStatusTransitionHistoryInnerFromJSON)),
        'transition_options': json['transition_options'],
        'workflow_stage': json['workflow_stage'],
    };
}

export function WorkflowStatusToJSON(json: any): WorkflowStatus {
    return WorkflowStatusToJSONTyped(json, false);
}

export function WorkflowStatusToJSONTyped(value?: WorkflowStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'can_transition': value['can_transition'],
        'current_stage': value['current_stage'],
        'dta_id': value['dta_id'],
        'next_actions': ((value['next_actions'] as Array<any>).map(WorkflowStatusNextActionsInnerToJSON)),
        'pending_approvals': ((value['pending_approvals'] as Array<any>).map(WorkflowStatusPendingApprovalsInnerToJSON)),
        'transition_history': ((value['transition_history'] as Array<any>).map(WorkflowStatusTransitionHistoryInnerToJSON)),
        'transition_options': value['transition_options'],
        'workflow_stage': value['workflow_stage'],
    };
}
